import { FC, useEffect, useState } from 'react';
import type { LottieComponentProps } from 'lottie-react';

interface LottieAnimationProps extends Omit<LottieComponentProps, 'animationData'> {
  animationData: object;
}

export const LottieAnimation: FC<LottieAnimationProps> = props => {
  const [Lottie, setLottie] = useState<FC<LottieComponentProps> | null>(null);

  useEffect(() => {
    // Skip dynamic import in test environment to avoid act() warnings
    /* istanbul ignore else: empty else branch */
    if (typeof jest !== 'undefined') {
      return;
    }

    // Dynamically import lottie-react only on client side
    void import('lottie-react').then(module => {
      setLottie(() => module.default);
    });
  }, []);
  /* istanbul ignore else: empty else branch */
  if (!Lottie) {
    // Return a placeholder or null during SSR
    return null;
  }

  return <Lottie {...props} />;
};
